<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="项目ID"
                        prop="keyword">
            <el-input placeholder="请输入项目ID"
                      clearable
                      v-model="search.projectid"></el-input>
          </el-form-item>

          <el-form-item label="用户ID"
                        prop="keyword">
            <el-input placeholder="请输入用户ID"
                      clearable
                      v-model="search.userid"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <!--<el-button type="primary"-->
        <!--size="small"-->
        <!--icon="sj-icon-export"-->
        <!--@click="onExportPage()"></el-button>-->
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="projectid"
                         label="项目ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="project_name"
                         label="项目名称"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="userid"
                         label="用户ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="allowance"
                         label="补贴金额"></el-table-column>
        <el-table-column prop="order_ids"
                         label="补贴工单"></el-table-column>
        <el-table-column prop="admin_name"
                         label="操作人">
        </el-table-column>
        <el-table-column prop="status"
                         :formatter="statusFormat"
                         label="状态">
        </el-table-column>
        <el-table-column prop="created_at"
                         label="添加日期"
                         width="190"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新日期"
                         width="190"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <div class="button-gutter">
              <el-button size="mini"
                         type="info"
                         @click="editStatus(scope.row.id, 2)" v-if="scope.row.status === 1">通过
              </el-button>

              <el-button type="danger"
                         size="mini"
                         @click="editStatus(scope.row.id, 3)" v-if="scope.row.status === 1">驳回
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../executive-budget.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
      },
      exportHeader: [
        {
          key: 'projectid',
          text: '项目ID',
        },
        {
          key: 'name',
          text: '执行预算分配名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    ...Vuex.mapState({
      statusMap: state => state.executiveBudget.options.approveStatus,
    }),
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getExecutiveApproveTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    dateFormat (row, column, cellValue, index) {
      return filter.formatDate(cellValue * 1000)
    },
    statusFormat (row, column, cellValue, index) {
      const statusMap = this.statusMap
      for (let i in statusMap) {
        if (statusMap.hasOwnProperty(i) && statusMap[i].value === cellValue * 1) {
          return statusMap[i].label
        }
      }
    },
    editStatus (id, status) {
      let info
      if (status === 2) {
        info = '通过审批'
      } else if (status === 3) {
        info = '驳回审批'
      }
      this.$confirm('确认' + info + '，是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('editExecutiveAuditStatus', {id: id, status: status}).then(() => {
          this.$message.success('操作成功')
          this.onRefresh()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/executive-budget/pages/ExecutiveApproveTable.vue